import {ArianeElement, ArianeStore} from "@digicerba/common";
import {CommandeFormationStore} from "@common/store/commande-formation.store";
import {ActivatedRoute, Router} from "@angular/router";
import {Component} from "@angular/core";


@Component({
  selector: 'recap-commande-component',
  templateUrl: './recap-commande.component.html',
  host: {'class': 'page'}
})
export class RecapCommandeComponent {

  etat: string;
  transactionId: string;
  montant: number;
  modePaiement: string;


  constructor(private router: Router, private route: ActivatedRoute, private commandeFormationStore: CommandeFormationStore, arianeStore: ArianeStore) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "Catalogue de formation",
        route: "/liste-formations"
      },
      {
        libelle: "Envoi des documents",
        route: ""
      }
    ];

    arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.commandeFormationStore.emptySaveCommandeFormation();
    this.commandeFormationStore.emptyCommandeFormation(true);
    this.modePaiement = this.route.snapshot.queryParams['mode'];
    if (this.modePaiement == null) {
      this.modePaiement = 'CHEQUE';
    }
    if (this.isPaiementEnLigne()) {
      this.etat = this.route.snapshot.queryParams['etat'];
      this.transactionId = this.route.snapshot.queryParams['transactionId'];
      this.montant = this.route.snapshot.queryParams['amount'];
    } else {
      this.etat = 'ACCEPTED';
    }
  }

  isEtatSuccess() {
    if (this.etat == 'ACCEPTED') {
      return true;
    } else {
      return false;
    }
  }

  isEtatCancel() {
    if (this.etat == 'CANCEL') {
      return true;
    } else {
      return false;
    }
  }

  isEtatFailure() {
    if (this.etat == 'FAILURE') {
      return true;
    } else {
      return false;
    }
  }

  isPaiementEnLigne() {
    if (this.modePaiement == 'EN_LIGNE') {
      return true;
    } else {
      return false;
    }
  }

  goToHome() {
    this.router.navigate(['cerba/liste-formations']);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/pages/commande/recap-commande/recap-commande.component.ts